import { Box, Grid, Stack, Toolbar, Typography, Dialog, DialogContent, DialogTitle, Tab, Tabs, } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import axios from 'axios';
import { API } from '../../utils/Api';
import { useSelector } from 'react-redux';
import { SummarizeOutlined } from '@mui/icons-material';
import ManagerCalendar from '../../components/ManagerCalendar';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import OtpModal from '../../components/OtpModal';
import AddonListing from '../../components/AddonListing';
import ProductsListing from '../../components/ProductsListing';
import DashoboardOptionsMenu from '../../components/DashboardOptionsMenu';

function ManagerDashboard() {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const storedOutletData = localStorage.getItem('outletData');
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openRecords, setOpenRecords] = useState(false);
  const userData = useSelector((state) => state.login.user);
  const [cashierRecords, setCashierRecords] = useState([]);
  const [selectedCashierId, setSelectedCashierId] = useState(null);
  const [dashboardData, setDashboardData] = useState([]);
  const [selectedCashierName, setSelectedCashierName] = useState('');
  const [activeTab, setActiveTab] = useState('products');

  let totalIndex = 0;

  const outletData = JSON.parse(storedOutletData);

  const fetchData = async () => {
    try {
      const url = `${API.BASE_URL}outlet/user/getShiftRecordsForCashiers`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setCashierRecords(response?.data?.data?.cashiers || []);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const getDashboardParams = async () => {
    try {
      setLoading(true);
      const requestUrl = `${API.BASE_URL}outlet/dashboard-params`;
      const response = await axios.get(requestUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log('Response of dashboard params', response.data.data);
      setDashboardData(response?.data?.data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenRecordsModal = async (cashierId) => {
    setSelectedCashierId(cashierId);
    const selectedCashier = cashierRecords?.find((cashier) => cashier._id === cashierId);
    if (selectedCashier) {
      setSelectedCashierName(selectedCashier.name);
    }
    setOpenRecords(true);
  };

  const handleCloseRecordsModal = () => {
    setOpenRecords(false);
  };

  useEffect(() => {
    // fetchData();
    getDashboardParams();
  }, []);

  return (
    <>
      <Box className="dashBoard">
        <Toolbar />
        <Grid container>
          <Grid item md={12} flexDirection={'column'}>
            <Grid md={12} sx={{ padding: '0px 0px 0px 0px', margin: '50px 0px 0 10px' }}>
              <DashoboardOptionsMenu />              
            </Grid>
            <Grid container md={11} sx={{ marginTop: '15px' }}>
              <Grid item md={12} marginBottom={2}>
                <Box sx={{ display: 'flex', justifyContent: 'center', margin: '20px 0 0 40px' }}>
                  <Tabs
                    value={activeTab}
                    onChange={(e, newValue) => setActiveTab(newValue)}
                    textColor="primary"
                    indicatorColor="primary"
                    sx={{
                      backgroundColor: '#fff',
                      borderRadius: 2,
                      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                      minHeight: 'unset'
                    }}
                  >
                    <Tab
                      label="Products"
                      value="products"
                      sx={{ minWidth: 120, fontWeight: 600 }}
                    />
                    <Tab
                      label="Addons"
                      value="addons"
                      sx={{ minWidth: 120, fontWeight: 600 }}
                    />
                  </Tabs>
                </Box>
              </Grid>
            </Grid>
            <Grid container md={11} sx={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)', borderRadius: '8px', padding: '0px 0px 0px 0px', margin: '21px 0px 25px 40px', backgroundColor: '#F6F6F6' }}>
              {activeTab === 'products' ? (
                <ProductsListing />
              ) : (
                <AddonListing />
              )}
            </Grid>
          </Grid>
          {/* <Grid item md={5}>
            {cashierRecords?.length > 0 && (
              <Grid
                container
                md={12}
                sx={{ borderRadius: '8px', margin: '50px 0px 0 20px' }}
              >
                <Grid
                  item
                  md={11}
                  sx={{
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
                    backgroundColor: '#fff',
                    borderRadius: '4px',
                    padding: '15px 0px 20px 0px',
                  }}
                >
                  <Typography
                    sx={{
                      color: '#000',
                      fontSize: '18px',
                      textAlign: 'center',
                      paddingBottom: '10px',
                    }}
                  >
                    Manage Cashiers
                  </Typography>
                  {cashierRecords?.map((cashier, index) => (
                    <Box
                      key={cashier._id}
                      sx={{
                        backgroundColor: index % 2 === 0 ? '#EDF9FF' : '#FFF',
                        padding: '10px 20px 15px 20px',
                      }}
                    >
                      <Typography
                        sx={{ color: '#000', fontSize: '14px', fontWeight: '600' }}
                      >
                        {cashier.name}
                      </Typography>
                      <Typography
                        sx={{ color: '#000', fontSize: '11px', paddingBottom: '8px' }}
                      >
                        In Out Time today
                      </Typography>
                      <Grid container justifyContent={'space-around'}>
                        <Grid
                          item
                          md={7}
                          sx={{
                            backgroundColor: index % 2 === 0 ? '#FFF' : '#EDF9FF',
                            borderRadius: '5px',
                            padding: '12px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <Stack direction={'row'}>
                            <Typography sx={{ fontWeight: '600', fontSize: '12px' }}>
                              In : 8:02am
                            </Typography>
                            <Typography
                              sx={{ marginLeft: '12px', fontWeight: '600', fontSize: '12px' }}
                            >
                              Out : 8:02am
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid
                          item
                          md={4}
                          className="cursor-p"
                          onClick={() => handleOpenRecordsModal(cashier._id)}
                          sx={{
                            backgroundColor: index % 2 === 0 ? '#FFF' : '#EDF9FF',
                            borderRadius: '5px',
                            padding: '6px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <Stack direction={'row'}>
                            <Typography sx={{ fontWeight: '600', fontSize: '10px' }}>
                              See previous <br />
                              records
                            </Typography>
                            <ChevronRight />
                          </Stack>
                        </Grid>
                      </Grid>
                    </Box>
                  ))}
                </Grid>
              </Grid>
            )}
          </Grid> */}
        </Grid>
      </Box >
      <Dialog open={openRecords} onClose={handleCloseRecordsModal} maxWidth="lg">
        <DialogTitle>Shift Record : {selectedCashierName}</DialogTitle>
        <DialogContent>
          <ManagerCalendar selectedCashierId={selectedCashierId} />
        </DialogContent>
      </Dialog>
      <Dialog open={otpModalOpen} onClose={() => setOtpModalOpen(false)} PaperProps={{ sx: { borderRadius: 5, overflow: 'hidden' } }}>
        <OtpModal />
      </Dialog>
    </>
  );
}

export default ManagerDashboard;
